// broadloom products (9 items)
export const productsBroadloom = [
  {
    id: 10,
    slug: "portico-nop-roll-goods",
    name: "Portico Nop",
    variant: "Roll Goods",
    type: "Broadloom Rolls & Sheets",
    category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",    productSheetPdf: "/Assets/pdf/portico-nop-roll-goods/PS_ISS_PorticoNop_RG.pdf",
    techSpecsPdf: "/Assets/pdf/portico-nop-roll-goods/PS_TechSpecs_PorticoNop_RG.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
    colorCount: 38,
    sizeFormat: "Sheets / Rolls",
    zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["neutral", "blue", "earth-tones", "green", "red", "charcoal", "grey", "tan", "brown", "multi-color"],
      patterns: ["berber", "modern"],
      budgetLevels: ["premium"],
    image: "/Assets/images/products/portico-nop-RG/portico-nop_thumbnail.jpg",
    heroImage: "/Assets/images/products/portico-nop-RG/portico-nop_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified" }
    ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats or Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
    keyFeatures: [
      "Superior quality you can rely on",
      "Versatility in wet and high-traffic areas",
      "Extra-high dirt absorption to keep interiors cleaner"
    ],
    gallery: [
      "/Assets/images/products/portico-nop-RG/PorticoNop_RG_d_runner.jpg",
      "/Assets/images/products/portico-nop-RG/PorticoNop_RG_b.jpg",
      "/Assets/images/products/portico-nop-RG/PorticoNop_RG_c.jpg",
      "/Assets/images/products/portico-nop-RG/portico-nop_hero-img.jpg",
      "/Assets/images/products/portico-nop-RG/PorticoNop_RG_a.jpg",
      "/Assets/images/products/portico-nop-ctg/portico_gym_fitness.jpg"
    ],
    swatches: [
      { name: "Autumn", image: "/Assets/images/products/portico-nop-RG/Autumn.jpg" },
      { name: "Azure", image: "/Assets/images/products/portico-nop-RG/Azure.jpg" },
      { name: "Black Shadow", image: "/Assets/images/products/portico-nop-RG/Black-Shadow.jpg" },
      { name: "Black", image: "/Assets/images/products/portico-nop-RG/Black.jpg" },
      { name: "Bright Red", image: "/Assets/images/products/portico-nop-RG/Bright-Red.jpg" },
      { name: "Burgundy", image: "/Assets/images/products/portico-nop-RG/Burgundy.jpg" },
      { name: "Cardinal Red", image: "/Assets/images/products/portico-nop-RG/Cardinal-Red.jpg" },
      { name: "Charcoal", image: "/Assets/images/products/portico-nop-RG/Charcoal.jpg" },
      { name: "Chocolate", image: "/Assets/images/products/portico-nop-RG/Chocolate.jpg" },
      { name: "Coir Natural", image: "/Assets/images/products/portico-nop-RG/Coir-natural.jpg" },
      { name: "Crimson", image: "/Assets/images/products/portico-nop-RG/Crimison.jpg" },
      { name: "Garnet", image: "/Assets/images/products/portico-nop-RG/Garnet.jpg" },
      { name: "Gold", image: "/Assets/images/products/portico-nop-RG/Gold.jpg" },
      { name: "Harvest", image: "/Assets/images/products/portico-nop-RG/Harvest.jpg" },
      { name: "Hunter Green", image: "/Assets/images/products/portico-nop-RG/Hunter-Green.jpg" },
      { name: "Kelly Green", image: "/Assets/images/products/portico-nop-RG/Kelly-Green.jpg" },
      { name: "Loden", image: "/Assets/images/products/portico-nop-RG/Loden.jpg" },
      { name: "Midnight Blue", image: "/Assets/images/products/portico-nop-RG/Midnight-Blue.jpg" },
      { name: "Natural Beige", image: "/Assets/images/products/portico-nop-RG/Natural-Beige.jpg" },
      { name: "Orange", image: "/Assets/images/products/portico-nop-RG/Orange.jpg" },
      { name: "Pink", image: "/Assets/images/products/portico-nop-RG/Pink.jpg" },
      { name: "Prism", image: "/Assets/images/products/portico-nop-RG/Prisim.jpg" },
      { name: "Purple", image: "/Assets/images/products/portico-nop-RG/Purple.jpg" },
      { name: "Rosewood", image: "/Assets/images/products/portico-nop-RG/Rosewood.jpg" },
      { name: "Royal Blue", image: "/Assets/images/products/portico-nop-RG/Royal-Blue.jpg" },
      { name: "Sand", image: "/Assets/images/products/portico-nop-RG/Sand.jpg" },
      { name: "Sky Blue", image: "/Assets/images/products/portico-nop-RG/Sky-Blue.jpg" },
      { name: "Steel Blue", image: "/Assets/images/products/portico-nop-RG/Steel-Blue.jpg" },
      { name: "Sterling", image: "/Assets/images/products/portico-nop-RG/Sterling.jpg" },
      { name: "Taupe", image: "/Assets/images/products/portico-nop-RG/Taupe.jpg" },
      { name: "Teak", image: "/Assets/images/products/portico-nop-RG/Teak.jpg" },
      { name: "Turquoise", image: "/Assets/images/products/portico-nop-RG/Turquoise.jpg" },
      { name: "Verdi Green", image: "/Assets/images/products/portico-nop-RG/Verdi-Green.jpg" },
      { name: "Walnut", image: "/Assets/images/products/portico-nop-RG/Walnut.jpg" },
      { name: "White", image: "/Assets/images/products/portico-nop-RG/White.jpg" },
      { name: "Yellow", image: "/Assets/images/products/portico-nop-RG/Yellow.jpg" },
      { name: "Zinc", image: "/Assets/images/products/portico-nop-RG/Zinc.jpg" }
    ],
    isPlaceholder: false,
    description: "Portico Nop helps you create clean, reliable entryways that perform in wet and high-traffic conditions, helping you protect interiors while maintaining a professional look. When entrances are exposed to moisture, dirt, and constant foot traffic, you need mating that delivers dependable performance without sacrificing style. Now available in roll goods, Portico Nop, our most popular logo mat material, offers warm neutrals, fashionable brights, and classic standard colors. It's our highest-quality product, designed to fit virtually any space and style. Made with 100% ASOTA® polypropylene fibers, this highly resilient non-woven carpet is UV stable, stain resistant, and built for long-term durability.",
    features: [
      "Dependable entryways in wet and high-traffic areas",
      "Wide range of colors"
    ],
    specifications: {
      faceWeight: "54 OZ ALL-WEATHER BERBER CARPET",
      construction: "Non-woven/needlepunched",
      pattern: "Hobnail (berber) pattern",
      fiberContent: "100% Solution-dyed UV stabilized ASOTA® polypropylene"
    }
  },
  {
      id: 37,
      slug: "astoria-nop-rg",
      name: "Astoria Nop",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/astoria-nop-rg/PS_ISS_AstoriaNop.pdf",
    techSpecsPdf: "/Assets/pdf/astoria-nop-rg/PS_TechSpecs_AstoriaNop_RG.pdf",
      saleSheetPdf: "/Assets/pdf/astoria-nop-rg/PS_ISS_AstoriaNop.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 6,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "charcoal", "blue", "earth-tones"],
      patterns: ["berber", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/astoria-nop-rg/astoria-nop-rg_thumbnail.jpg",
      heroImage: "/Assets/images/products/astoria-nop-rg/astoria-nop-rg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats or Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
      keyFeatures: ["UV stable dense 37oz. construction", "Can be cut into any shape without edge ravel", "Great choice for logo and plain mats"],
      gallery: ["/Assets/images/products/astoria-nop-rg/astoria_hotel.jpg", "/Assets/images/products/astoria-nop-rg/astoria-nop-rg_gallery_1.jpg", "/Assets/images/products/astoria-nop-rg/astorianop_closeup.jpg", "/Assets/images/products/astoria-nop-rg/fenway_lobby.jpg", "/Assets/images/products/astoria-nop-rg/astoria_corridor.jpg", "/Assets/images/products/astoria-nop-rg/astoria_revolving_door_mat.jpg"],
      swatches: [
        {name: "Steel Blue", image: "/Assets/images/products/astoria-nop-rg/swatches/Steel-Blue.jpg"},
        {name: "Zinc", image: "/Assets/images/products/astoria-nop-rg/swatches/Zinc.jpg"},
        {name: "Sisal", image: "/Assets/images/products/astoria-nop-rg/swatches/Sisal.jpg"},
        {name: "Sterling", image: "/Assets/images/products/astoria-nop-rg/swatches/Sterling.jpg"},
        {name: "Charcoal", image: "/Assets/images/products/astoria-nop-rg/swatches/Charcoal.jpg"},
        {name: "Walnut", image: "/Assets/images/products/astoria-nop-rg/swatches/Walnut.jpg"}
      ],
      isPlaceholder: false,
      description: "At busy building entrances, matting needs to stay dependable without becoming difficult to manage. Astoria Nop is designed with dense fibers that hold their shape under heavy foot traffic while remaining lightweight enough to handle during installation and routine cleaning. Its UV-stable construction performs reliably in changing conditions, and the material can be cut into custom shapes without fraying, making it a practical choice for both standard entrance mats and branded logo applications.",
      features: ["UV stable dense 37oz. construction", "Can be cut into any shape without edge ravel", "Great choice for logo and plain mats"],
      specifications: {}
    },
  {
      id: 39,
      slug: "avenue-rib-rg",
      name: "Avenue Rib",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/avenue-rib-rg/PS_ISS_AvenueRib.pdf",
    techSpecsPdf: "/Assets/pdf/avenue-rib-rg/PS_TechSpecs_AvenueRib_RG.pdf",
      saleSheetPdf: "/Assets/pdf/avenue-rib-rg/PS_ISS_AvenueRib.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 1,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["charcoal"],
      patterns: ["ribbed", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/avenue-rib-rg/avenue_rib_elevator.jpg",
      heroImage: "/Assets/images/products/avenue-rib-rg/avenue-rib-rg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats or Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
      keyFeatures: ["High-performance double-ribbed construction", "Solution-dyed, UV stabilized ASOTA\u00ae polypropylene fiber", "Available in sheet/roll goods"],
      gallery: ["/Assets/images/products/avenue-rib-rg/avenue_rib_stairwell.jpg", "/Assets/images/products/avenue-rib-rg/avenue_rib_elevator.jpg", "/Assets/images/products/avenue-rib-rg/avenue_rib_d_vestibule.jpg", "/Assets/images/products/avenue-rib-rg/avenue_rib_drugstore.jpg", "/Assets/images/products/avenue-rib-rg/avenue_rib_overhead.jpg"],
      swatches: [
        {name: "Charcoal", image: "/Assets/images/products/avenue-rib-rg/swatches/Charcoal.jpg"}
      ],
      isPlaceholder: false,
      description: "Facilities with medium-to-heavy foot traffic need entrance flooring that can handle daily wear without losing its appearance. Avenue Rib provides a durable solution with rich, dense all-weather fibers and a distinctive double-rib pattern designed for reliable performance. Its heavy 44 oz. construction helps resist crushing, while solution-dyed, UV- stabilized ASOTA® polypropylene fibers and a premium composite rubber backing allow the material to perform in demanding climates. Easy to handle, install, and cut to shape without edge ravel, Avenue Rib delivers dependable matting for busy commercial spaces.",
      features: ["High-performance double-ribbed construction", "Solution-dyed, UV stabilized ASOTA\u00ae polypropylene fiber", "Available in sheet/roll goods"],
      specifications: {}
    },
  {
      id: 40,
      slug: "axis-rib-rg",
      name: "Axis Rib",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/axis-rib-rg/PS_ISS_AxisRib.pdf",
    techSpecsPdf: "/Assets/pdf/axis-rib-rg/PS_TechSpecs_AxisRib_RG.pdf",
      saleSheetPdf: "/Assets/pdf/axis-rib-rg/PS_ISS_AxisRib.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 3,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "charcoal", "black"],
      patterns: ["ribbed", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/axis-rib-rg/axis-rib-rg_thumbnail.jpg",
      heroImage: "/Assets/images/products/axis-rib-rg/axis-rib-rg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats or Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
      keyFeatures: ["Resilient in extreme climate conditions", "Easily cut into any shape without edge ravel"],
      gallery: ["/Assets/images/products/axis-rib-rg/axis-rib-rg_thumbnail.jpg", "/Assets/images/products/axis-rib-rg/axis-rib-rg_hero.jpg", "/Assets/images/products/axis-rib-rg/axis-rib-rg_gallery_1.jpg", "/Assets/images/products/axis-rib-rg/axis-rib-rg_gallery_2.jpg", "/Assets/images/products/axis-rib-rg/axis-rib-rg_college.jpg"],
      swatches: [
        {name: "Blackshadow2343", image: "/Assets/images/products/axis-rib-rg/swatches/Atlas_BlackShadow2343.jpg"},
        {name: "Charcoal1198", image: "/Assets/images/products/axis-rib-rg/swatches/Atlas_Charcoal1198.jpg"},
        {name: "Sterling2344", image: "/Assets/images/products/axis-rib-rg/swatches/Atlas_Sterling2344.jpg"}
      ],
      isPlaceholder: false,
      description: "Your facility’s entrance works hard, and without the right matting, dirt, moisture, and heavy traffic quickly wear down interior floors. Axis Rib helps solve that problem with a durable entrance mat designed to perform in demanding environments. Its dense 44 oz. construction delivers long-term comfort and resilience, while solution-dyed, UV-stabilized ASOTA® polypropylene fibers resist crushing and staining. The classic corduroy rib pattern captures debris and allows the material to be cut to shape without edge ravel, giving architects and facility managers a reliable mating solution that performs in high-traffic spaces and extreme climate conditions.",
      features: ["Resilient in extreme climate conditions", "Easily cut into any shape without edge ravel"],
      specifications: {}
    },
  {
      id: 52,
      slug: "kensington-rolls-rg",
      name: "Kensington Rolls",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/kensington-rolls-rg/PS_ISS_Kensington_RG.pdf",
    techSpecsPdf: "/Assets/pdf/kensington-rolls-rg/PS_TechSpecs_Kensington_RG.pdf",
      saleSheetPdf: "/Assets/pdf/kensington-rolls-rg/PS_ISS_Kensington_RG.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 5,
      sizeFormat: "Rolls / Sheets",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "blue", "brown", "charcoal", "red"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/kensington-rolls-rg/kensington_hotel_thumbnail.jpg",
      heroImage: "/Assets/images/products/kensington-rolls-rg/kensington-rolls-rg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "PA6 Space Dyed Nylon",
      construction: "Tufted",
      backing: "Premium Composite Rubber",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats, Glue -down",
      recommendedZone: "Zones 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
      keyFeatures: ["Beautiful, striated design available in five colors", "Tufted 30 oz nylon provides superior performance", "Available in carpet tile, sheet/roll goods and custom/logo matting"],
      gallery: ["/Assets/images/products/kensington-rolls-rg/kensington-rolls-rg_gallery_2.jpg", "/Assets/images/products/kensington-rolls-rg/kensington_shoe_boutique.jpg", "/Assets/images/products/kensington-rolls-rg/kensington_elevator_b7.jpg", "/Assets/images/products/kensington-rolls-rg/kensington_elevator_overhead.jpg", "/Assets/images/products/kensington-rolls-rg/kensington_lounge.jpg", "/Assets/images/products/kensington-rolls-rg/kensington_windsor_taupe_pool.jpg", "/Assets/images/products/kensington-rolls-rg/kensington-rolls-rg_hero.jpg", "/Assets/images/products/kensington-rolls-rg/kensington-rolls-rg_gallery_1.jpg"],
      swatches: [
        {name: "Navy", image: "/Assets/images/products/kensington-rolls-rg/swatches/Windsor_03_NavyBlue_V2.jpg"},
        {name: "Red", image: "/Assets/images/products/kensington-rolls-rg/swatches/Windsor_05_Red.jpg"},
        {name: "Dark Grey", image: "/Assets/images/products/kensington-rolls-rg/swatches/Windsor_01_DarkGrey.jpg"},
        {name: "Charcoal", image: "/Assets/images/products/kensington-rolls-rg/swatches/Windsor_02_CharcoalBlack_V2.jpg"},
        {name: "Taupe", image: "/Assets/images/products/kensington-rolls-rg/swatches/Windsor_04_Taupe_V2.jpg"}
      ],
      isPlaceholder: false,
      description: "Busy commercial spaces need flooring that looks refined while standing up to constant traffic. Kensington delivers both by combining durable performance with a sophisticated striated design inspired by patterns found in nature. Its tufted 30 oz. nylon construction is built to handle demanding environments while adding subtle movement and warmth to the space. Available in carpet tile, sheet/roll goods, and custom logo matting, Kensington gives designers and facility managers a flexible solution that elevates interiors without sacrificing durability. PARAGRAPH 2 – Inspired by striae patterns found in nature, this premium product’s subtle yet warm design adds energy and movement to any space.",
      features: ["Beautiful, striated design available in five colors", "Tufted 30 oz nylon provides superior performance", "Available in carpet tile, sheet/roll goods and custom/logo matting"],
      specifications: {}
    },
  {
      id: 55,
      slug: "natural-coco-rg",
      name: "Natural Coco",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/natural-coco-rg/PS_ISS_NaturalCoco.pdf",
    techSpecsPdf: "/Assets/pdf/natural-coco-rg/PS_TechSpecs_NatCoco_RG.pdf",
      saleSheetPdf: "/Assets/pdf/natural-coco-rg/PS_ISS_NaturalCoco.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
      colorCount: 7,
      sizeFormat: "Rolls / Sheets",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "black", "blue", "green", "red", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/natural-coco-rg/natural-coco-rg_thumbnail.jpg",
      heroImage: "/Assets/images/products/natural-coco-rg/natural-coco-rg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "Natural Coconut Fibers",
      construction: "Fusion Bonded",
      backing: "Vinyl",
      thickness: "0.625 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats or Glue-down",
      recommendedZone: "Zones 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
      keyFeatures: ["Made with natural coconut/coir fibers", "Provides an unparalleled premium", "Natural look and feel for indoor applications"],
      gallery: ["/Assets/images/products/natural-coco-rg/natural-coco-rg_hero.jpg", "/Assets/images/products/natural-coco-rg/natcoco_doorway_green.jpg", "/Assets/images/products/natural-coco-rg/natcoco_retail.jpg", "/Assets/images/products/natural-coco-rg/natcoco_black_rg.jpg", "/Assets/images/products/natural-coco-rg/natcoco_4.jpg", "/Assets/images/products/natural-coco-rg/coir_edging.jpg"],
      swatches: [
        {name: "Natural", image: "/Assets/images/products/natural-coco-rg/swatches/2_natcoco_natural.jpg"},
        {name: "Blue", image: "/Assets/images/products/natural-coco-rg/swatches/coco_blue_print.jpg"},
        {name: "Black", image: "/Assets/images/products/natural-coco-rg/swatches/2_natcoco_black.jpg"},
        {name: "Brown", image: "/Assets/images/products/natural-coco-rg/swatches/2_natcoco_brown.jpg"},
        {name: "Green", image: "/Assets/images/products/natural-coco-rg/swatches/2_natcoco_green.jpg"},
        {name: "Grey", image: "/Assets/images/products/natural-coco-rg/swatches/2_natcoco_grey.jpg"},
        {name: "Red", image: "/Assets/images/products/natural-coco-rg/swatches/2_natcoco_red.jpg"}
      ],
      isPlaceholder: false,
      description: "When you want an entrance that makes a natural first impression, Natural Coco provides a simple, effective solution. Made from durable coconut coir fibers, this mat helps capture dirt and debris while delivering an authentic, natural appearance. Designed for recessed wells and entryways, Natural Coco supports facilities looking to project an environmentally conscious image while maintaining a clean, professional entry. It can also be customized with or without a logo to complement the space.",
      features: ["Made with natural coconut/coir fibers", "Provides an unparalleled premium", "Natural look and feel for indoor applications"],
      specifications: {}
    },
  {
      id: 59,
      slug: "premier-nop-tile-rg",
      name: "Premier Nop",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/premier-nop-tile-rg/PS_ISS_PremierNop_RG.pdf",
    techSpecsPdf: "/Assets/pdf/premier-nop-tile-rg/PS_TechSpecs_PremierNop__RG.pdf",
      saleSheetPdf: "/Assets/pdf/premier-nop-tile-rg/PS_ISS_PremierNop_RG.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 11,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["neutral", "grey", "blue", "earth-tones", "red", "green"],
      patterns: ["berber", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/premier-nop-tile-rg/premier-nop-tile-rg_thumbnail.jpg",
      heroImage: "/Assets/images/products/premier-nop-tile-rg/premier-nop-tile-rg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats or Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
      keyFeatures: ["Made with 100% ASOTA\u00ae polypropylene fibers", "UV stable, stain resistant", "Durable and a highly resilient non-woven carpet"],
      gallery: ["/Assets/images/products/premier-nop-tile-rg/premier-nop-tile-rg_hero.jpg", "/Assets/images/products/premier-nop-tile-rg/premier_accessible_entrance.jpg", "/Assets/images/products/premier-nop-tile-rg/premier_target_produce.jpg", "/Assets/images/products/premier-nop-tile-rg/premier-nop-tile-rg_gallery_2.jpg"],
      swatches: [
        {name: "Sisal 1099", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Sisal-1099.jpg"},
        {name: "Chocolate 912", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Chocolate-912.jpg"},
        {name: "Anthracite 907", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Anthracite-907.jpg"},
        {name: "Beige 918", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Beige-918.jpg"},
        {name: "Azure 5181", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Azure-5181.jpg"},
        {name: "Bordeaux 7178", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Bordeaux-7178.jpg"},
        {name: "Midnight Blue 5154", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Midnight-Blue-5154.jpg"},
        {name: "Aspen 6265", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Aspen-6265.jpg"},
        {name: "Sterling 2344", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Sterling-2344.jpg"},
        {name: "Harvest 1244", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Harvest-1244.jpg"},
        {name: "Black Shadow 2343", image: "/Assets/images/products/premier-nop-tile-rg/swatches/Black-Shadow-2343.jpg"}
      ],
      isPlaceholder: false,
      description: "Daily foot traffic brings in grit, moisture, and debris that can quickly degrade surrounding floors. Premier Nop helps manage that challenge with a durable fiber-bond berber surface designed to capture contaminants before they spread through the building. The high-heel friendly construction performs reliably in busy commercial entrances, while its strong dirt-trapping capability helps reduce maintenance and protect interior flooring. Premier Nop delivers dependable entrance protection in a practical, cost-effective matting solution.",
      features: ["Made with 100% ASOTA\u00ae polypropylene fibers", "UV stable, stain resistant", "Durable and a highly resilient non-woven carpet"],
      specifications: {}
    },
  {
      id: 64,
      slug: "superior-nop-rg",
      name: "Superior Nop",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/superior-nop-rg/PS_ISS_SuperiorNop.pdf",
    techSpecsPdf: "/Assets/pdf/superior-nop-rg/PS_TechSpecs_SuperiorNop_RG.pdf",
      saleSheetPdf: "/Assets/pdf/superior-nop-rg/PS_ISS_SuperiorNop.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 3,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "charcoal", "brown"],
      patterns: ["berber", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/superior-nop-rg/superior-nop-rg_thumbnail.jpg",
      heroImage: "/Assets/images/products/superior-nop-rg/superior-nop-rg_gallery_1.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.57 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mats or Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
    },
      keyFeatures: ["A particularly effective and stylish entrance flooring", "Industrial strength mating", "Tough yet flexible and easy to move"],
      gallery: ["/Assets/images/products/superior-nop-rg/superior-nop-rg_gallery_1.jpg", "/Assets/images/products/superior-nop-rg/superior-nop-rg_gallery_2.jpg", "/Assets/images/products/superior-nop-rg/superior-nop-rg_gallery_3.jpg", "/Assets/images/products/superior-nop-rg/superior-nop-rg_gallery_4.jpg", "/Assets/images/products/superior-nop-rg/superior-nop-rg_gallery_5.jpg"],
      swatches: [
        {name: "Superior Nop   Gris Charcoal 2098", image: "/Assets/images/products/superior-nop-rg/swatches/Superior-Nop-Gris-Charcoal-2098.jpg"},
        {name: "Superior Nop   Nugget 2097", image: "/Assets/images/products/superior-nop-rg/swatches/Superior-Nop-Nugget-2097.jpg"},
        {name: "Superior Nop   Stone 2099", image: "/Assets/images/products/superior-nop-rg/swatches/Superior-Nop-Stone-2099.jpg"}
      ],
      isPlaceholder: false,
      description: "Busy entrances face constant pressure from dirt, moisture, and heavy foot traffic, making durable matting essential. Superior Nop provides a reliable solution designed to perform in all weather conditions while maintaining a clean, professional appearance. Its industrial-strength construction delivers exceptional dirt absorption and resilience yet remains flexible and easy to handle during installation or maintenance. Suitable for both indoor and outdoor applications, Superior Nop helps facilities keep entryways cleaner and safer without sacrificing style.",
      features: ["A particularly effective and stylish entrance flooring", "Industrial strength mating", "Tough yet flexible and easy to move"],
      specifications: {}
    },
  {
      id: 66,
      slug: "synthetic-coco-rolls-rg",
      name: "Synthetic Coco - Rolls",
      variant: "Broadloom Rolls & Sheet Goods",
      type: "Broadloom Rolls & Sheet Goods",
      category: "Broadloom Rolls & Sheets",

    categoryId: "broadloom",
      productSheetPdf: "/Assets/pdf/synthetic-coco-rolls-rg/PS_ISS_SyntheticCoco.pdf",
    techSpecsPdf: "/Assets/pdf/synthetic-coco-rolls-rg/PS_TechSpecs_SynCoco_RG.pdf",
      saleSheetPdf: "/Assets/pdf/synthetic-coco-rolls-rg/PS_ISS_SyntheticCoco.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 1,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["tan"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/synthetic-coco-rolls-rg/syncoco_pov_above.jpg",
      heroImage: "/Assets/images/products/synthetic-coco-rolls-rg/synthetic-coco-rolls-rg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
      comparisonSpecs: {
        material: "ASOTA® polypropylene fibers",
        construction: "Non-woven",
        backing: "Premium Composite Rubber",
        thickness: "0.34 inch",
        trafficRating: "Medium",
        slipResistance: "Yes",
        installationType: "Loose Lay Mats or Glue-down",
        recommendedZone: "Zones 1, 2, 3",
        bestUseCase: "Custom Inlaid matting, all indoor/outdoor installs"
      },
    keyFeatures: ["100 % solution-dyed UV stabilized polypropylene fibers are stained and fade resistant", "Heavy, dense face weight", "Ideal for long-term usage in even the most heavily trafficked areas"],
      gallery: ["/Assets/images/products/synthetic-coco-rolls-rg/syncoco_pov_above.jpg", "/Assets/images/products/synthetic-coco-rolls-rg/syn-coco_gallery_1.jpg", "/Assets/images/products/synthetic-coco-rolls-rg/syncoco_library_entrance.jpg"],
      swatches: [
        {name: "Natural", image: "/Assets/images/products/synthetic-coco-rolls-rg/swatches/Syn-Coco_Natural.jpg"}
      ],
      isPlaceholder: false,
      description: "For facilities that want the look of natural coco with greater durability, Synthetic Coco delivers a practical indoor/outdoor entrance solution. Designed with dense, solution-dyed UV-stabilized polypropylene fibers, it provides the appearance of natural coir without the shedding or maintenance concerns. Its heavy face weight resists wearing in high- traffic areas, while the absorbent surface helps capture moisture to keep surrounding floors safer and drier. Ideal for recessed mat wells or wall-to-wall installations, Synthetic Coco combines natural aesthetics with dependable long-term performance.",
      features: ["100 % solution-dyed UV stabilized polypropylene fibers are stained and fade resistant", "Heavy, dense face weight", "Ideal for long-term usage in even the most heavily trafficked areas"],
      specifications: {}
    },
];
